module.exports = __webpack_public_path__ + "media/images/icons/country_flags/gs-a193265c7b547240dd9ec17b17b5592a.svg";